import React from "react";

function FacialBoneFractures() {
  return <div>Facial Bone Fractures</div>;
}

export default FacialBoneFractures;
